(function () {
  if (window.__stickeredCustomTextNativeSizeReady) return;
  window.__stickeredCustomTextNativeSizeReady = true;

  function findSection(node) {
    return (node && node.closest && node.closest('[id^="ProductSection-"]')) ||
      document.querySelector('[id^="ProductSection-"]');
  }

  function findNativeSizeWrapper(section, slot) {
    if (!section) return null;

    var selects = Array.prototype.slice.call(section.querySelectorAll('.single-option-selector'));
    var slotSelect = slot && slot.querySelector && slot.querySelector('.single-option-selector');

    var sizeSelect = selects.find(function (select) {
      if (select === slotSelect) return false;
      return String(select.getAttribute('data-name') || '').toLowerCase() === 'size';
    }) || selects.find(function (select) {
      return select !== slotSelect;
    });

    if (!sizeSelect) return null;

    return sizeSelect.closest('.selector-wrapper') || sizeSelect.parentElement;
  }

  function styleNativeSize(wrapper) {
    if (!wrapper) return;

    wrapper.classList.add('stk-custom-text-native-size');

    var label = wrapper.querySelector('label');
    var select = wrapper.querySelector('select');

    if (label) {
      label.textContent = 'Size';
      label.classList.add('stk-custom-text-native-size__label');
    }

    if (select) {
      select.classList.add('stk-custom-text-native-size__select');
    }
  }

  function moveNativeSize() {
    var slot = document.querySelector('[data-stk-custom-text-native-size-slot], .stk-custom-text-native-size-slot, #stk-custom-text-native-size-slot');
    if (!slot) return false;

    var section = findSection(slot);
    var wrapper = findNativeSizeWrapper(section, slot);

    if (!wrapper) return false;

    styleNativeSize(wrapper);

    if (!slot.contains(wrapper)) {
      wrapper.dataset.stickeredCustomTextNativeSizeMoved = 'true';
      slot.appendChild(wrapper);
    }

    return true;
  }

  function init() {
    moveNativeSize();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  var attempts = 0;
  var retryTimer = setInterval(function () {
    attempts += 1;

    if (moveNativeSize() || attempts >= 30) {
      clearInterval(retryTimer);
    }
  }, 300);
})();
